import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/UserSwitch.svg?component
var UserSwitch_exports = /* @__PURE__ */ __exportAll({
	default: () => UserSwitch_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M11.101 1.488H4.83a1 1 0 0 0-1 1v6.614m9.069 13.41h6.272a1 1 0 0 0 1-1v-6.614" }, null, -1), createElementVNode("path", { d: "m1.23 6.5 2.6 2.6 2.601-2.6m16.339 11-2.6-2.6-2.601 2.6M5.505 18.546a2.551 2.551 0 1 0 0-5.103 2.551 2.551 0 0 0 0 5.103m4.277 3.965c-.559-1.83-2.29-3.202-4.276-3.202-1.988 0-3.718 1.372-4.277 3.202m17.264-15.92a2.551 2.551 0 1 0 0-5.103 2.551 2.551 0 0 0 0 5.103m4.277 3.965c-.559-1.83-2.289-3.202-4.276-3.202s-3.718 1.372-4.276 3.202" }, null, -1)])]);
}
var UserSwitch_default = { render: render$1 };
//#endregion
export { UserSwitch_exports, UserSwitch_default as default, render$1 as render };

//# sourceMappingURL=UserSwitch.svg_component.js.map